<template>
  <div class="bg-bluegray-50 my-8 px-16 py-24 rounded-4">
    <p class="font-bold">
      Garanti fra If skadeforsikring
    </p>
    <p class="mb-0">
      Ikke tilgjengelig
    </p>
  </div>
</template>
